import { supabase } from "./supabaseClient";
import type { LeadScore, VLeadParado } from "./types";

/** v_leads_parados NAO pre-filtra por dias: o front escolhe o corte. Leads
 * adiados para o futuro ja saem da view (decisao do backend, nao filtrar de
 * novo aqui). */
export async function fetchLeadsParados(minDias: number): Promise<VLeadParado[]> {
  const { data, error } = await supabase
    .from("v_leads_parados")
    .select("*")
    .gte("dias_parado", minDias)
    .order("dias_parado", { ascending: false });
  if (error) throw new Error(error.message);
  return (data ?? []) as unknown as VLeadParado[];
}

/** Score por sinal individual (heuristica declarada, nao IA — ver comentario
 * na migration). Traz `componentes` sempre: o numero sozinho e caixa preta. */
export async function fetchLeadScores(): Promise<LeadScore[]> {
  const { data, error } = await supabase.from("v_lead_score").select("*");
  if (error) throw new Error(error.message);
  return (data ?? []) as unknown as LeadScore[];
}

export async function fetchLeadScore(leadId: string): Promise<LeadScore | null> {
  const { data, error } = await supabase
    .from("v_lead_score")
    .select("*")
    .eq("lead_id", leadId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return data as unknown as LeadScore | null;
}
